import { AiSparkle16 } from 'ui/icons/aurora/16px/AiSparkle16';
import { useCampaignQueryContext } from 'modules/campaignIndex/campaignFolders/contexts/CampaignQueryContext';
import {
  StyledSuggestionButton,
  StyledButtonText,
} from 'modules/ai/nba/components/campaigns/NBACampaignsSlideOver.styles';
import { BUTTON_VARIANTS } from 'ui/button/constants';
import { CounterBadge } from 'ui/badge/components';

export interface NBACampaignsButtonProps {
  onClick?: (e: React.MouseEvent) => void;
}

export const NBACampaignsButton = ({ onClick }: NBACampaignsButtonProps) => {
  const { nbaEnabledCampaignIds } = useCampaignQueryContext();
  return (
    <StyledSuggestionButton
      data-test={'nba-campaigns-btn'}
      onClick={onClick}
      variant={BUTTON_VARIANTS.SECONDARY}
    >
      <AiSparkle16 />
      <StyledButtonText>Suggestions</StyledButtonText>
      {nbaEnabledCampaignIds?.length > 0 && (
        <CounterBadge data-test="nba-campaigns-counter">
          {nbaEnabledCampaignIds.length}
        </CounterBadge>
      )}
    </StyledSuggestionButton>
  );
};
